<!-- Admin Edit Pix Detail Record -->

<template>

	<div class="adm-edit-pix-detail">
		
		<div class="left-frame">
<!-- 
			<div class="idx-box wi8_font">
				#{{ idx }}
			</div>
 -->
			<div class="pic-frame">
				<img class="center_me" :src="rec.imgUrl" />
			</div>
			<div class="id-box">
				{{ rec.itemId }}
			</div>
		</div>

		<div class="right-frame">
			<div class="lab-box">Prime:</div>
			<div :class="rec.primary? 'chk-box active-blue': 'chk-box'" @click="clickCheckFlag('primary')">
				<UniIcon 
					ico="check" 
					color="#FFF" 
					fit="1"
					pad="0"				
				/>
			</div>
			
			<div class="h-spacer" />
			<div :class="(idx==0)? 'chk-box': 'chk-box active-blue'" @click="clickMove(-1)">
				<UniIcon 
					ico="arrow" 
					color="#FFF" 
					fit="1"
					pad="0"				
				/>
			</div>
			<div class="v-spacer" />

			<div class="lab-box">Merit:</div>
			<div :class="(rec.merit=='ok')? 'chk-box active': 'chk-box'" @click="clickCheckFlag('merit')">
				<UniIcon 
					ico="check" 
					color="#FFF" 
					fit="1"
					pad="0"				
				/>
			</div>
			<div class="v-spacer" />

			<div class="lab-box">Live:</div>
			<div :class="(rec.live=='1')? 'chk-box active': 'chk-box'" @click="clickCheckFlag('live')">
				<UniIcon 
					ico="check" 
					color="#FFF" 
					fit="1"
					pad="0"				
				/>
			</div>
			<div class="v-spacer" />

			<div class="lab-box">Stage:</div>
			<div class="val-box">{{ rec.stage }} </div>
			<div class="h-spacer" />
			<div :class="(idx<current.pix.length-1)? 'chk-box rot-180 active-blue': 'chk-box rot-180'" @click="clickMove(1)">
				<UniIcon 
					ico="arrow" 
					color="#FFF" 
					fit="1"
					pad="0"				
				/>
			</div>
		</div>
	</div>

</template>

<script>
import { mapState } from 'vuex';
export default {
	props: {
		rec: {},
		idx: Number,
	},
	computed: {
		...mapState('app', ['current']),
	},
	methods: {
		clickMove(amount) {
			const data = {
				step: "current",
				idx: this.idx,
				amount: amount,
			};
			this.$store.dispatch('app/movePic', data);
		},
		clickCheckFlag(flagName) {
			const data = {
				step: "current",
				idx: this.idx,
				flagName: flagName,	
			};
			this.$store.dispatch('app/clickCheckFlag', data);
		},
	}
}
</script>

<style scoped>

.adm-edit-pix-detail {
	width: calc(100% - 10px);
	height: 140px;
	overflow: hidden;
	padding: 5px;
	white-space: nowrap;
	border-radius: 8px;
	border: solid 1px #999;
}

.left-frame {
	display: inline-block;
	width: 150px;
	height: 140px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #69C;
}

.right-frame {
	display: inline-block;
	width: 120px;
	height: 130px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #C30;
}

.idx-box {
	display: inline-block;
	width: 30px;
	height: 25px;
	overflow: hidden;
	white-space: nowrap;
	vertical-align: top;
	padding: 2px 0px 0px 2px;
	border: solid 1px #369;
}

.pic-frame {
	display: inline-block;
	width: 144px;
	height: 108px;
	overflow: hidden;
	vertical-align: top;
	border-radius: 8px;
	border: solid 1px #999;
}

.id-box {
	height: 25px;
	overflow: hidden;
	white-space: nowrap;
	padding: 2px 5px 0px 5px;
	text-align: right;
	border: solid 0px #369;
}

.lab-box {
	display: inline-block;
	width: 50px;
	height: 26px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	text-align: right;
	padding: 2px 5px 0px 0px;
	border: solid 0px #369;
}

.val-box {
	display: inline-block;
	width: 26px;
	height: 26px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	text-align: left;
	padding: 2px 0px 0px 0px;
	border: solid 0px #369;
}

.chk-box {
	display: inline-block;
	width: 26px;
	height: 26px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	cursor: pointer;
	background-color: #EEE;
	border-radius: 4px;
	border: solid 1px #999;
}

.active {
	background-color: #393;
}

.active-blue {
	background-color: #369;
}

.rot-180 {
	transform: rotate(180deg);
}

.v-spacer {
	width: 10px;
	height: 3px;
	border: solid 0px #999;
}

.h-spacer {
	display: inline-block;
	width: 10px;
	height: 5px;
	vertical-align: top;
	border: solid 0px #999;
}

.center_me {
	display:inline-block;
	max-width: 100%;
	max-height: 100%;
	position: relative;
	top: 50%;
	left: 50%;
	-webkit-transform: translateX(-50%) translateY(-50%);
	-moz-transform: translateX(-50%) translateY(-50%);
	-ms-transform: translateX(-50%) translateY(-50%);
	-o-transform: translateX(-50%) translateY(-50%);
	transform: translateX(-50%) translateY(-50%);
	border: solid 0px #C30;
}

</style>
